import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsHeader = ({ stats, technicianName }) => {
  const currentDate = new Date()?.toLocaleDateString('de-DE', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="bg-primary text-primary-foreground rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h1 className="text-lg font-semibold">Hallo, {technicianName}!</h1>
          <p className="text-primary-foreground/80 text-sm">{currentDate}</p>
        </div>
        <div className="w-12 h-12 bg-primary-foreground/20 rounded-full flex items-center justify-center">
          <Icon name="User" size={24} color="white" />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div className="text-center">
          <div className="flex items-center justify-center mb-1">
            <Icon name="Clock" size={16} className="mr-1" />
            <span className="text-2xl font-bold">{stats?.assigned}</span>
          </div>
          <p className="text-xs text-primary-foreground/80">Zugewiesen</p>
        </div>
        <div className="text-center">
          <div className="flex items-center justify-center mb-1">
            <Icon name="Play" size={16} className="mr-1" />
            <span className="text-2xl font-bold">{stats?.inProgress}</span>
          </div>
          <p className="text-xs text-primary-foreground/80">In Bearbeitung</p>
        </div>
        <div className="text-center">
          <div className="flex items-center justify-center mb-1">
            <Icon name="CheckCircle" size={16} className="mr-1" />
            <span className="text-2xl font-bold">{stats?.completed}</span>
          </div>
          <p className="text-xs text-primary-foreground/80">Abgeschlossen</p>
        </div>
      </div>
    </div>
  );
};

export default StatsHeader;